import styles from './style.module.scss';
import { PageHeader } from 'components';
import { Table, Divider } from 'antd';
import Filters from 'components/filters';
import useQR from '../useQR';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import OldDataModal from './oldDataModal';

const QrMainPage = () => {
  const { t } = useTranslation();
  const { data, columns, filters, loading, onChangeTableFilter } = useQR();

  return (
    <>
      <PageHeader title={t('QR code').toUpperCase()} />
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.qrs}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
          scroll={{ x: 1500 }}
        // bordered
        />
        <Routes>
          <Route
            path={':id'}
            element={<OldDataModal data={data} loading={loading} />}
          />
        </Routes>
      </div>
    </>
  );
};

export default QrMainPage;
